import { useState, useEffect } from 'react';

export default function FloatingBookButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.querySelector('section');
    if (!hero) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(!entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  const handleClick = () => {
    const el = document.getElementById('tutoring-form');
    el?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      className={`fixed bottom-8 left-8 z-50 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-6 pointer-events-none'
      }`}
    >
      <button
        onClick={handleClick}
        className="flex items-center gap-3 bg-emerald-600 hover:bg-emerald-700 active:scale-95 text-white font-semibold px-6 py-4 rounded-full shadow-2xl transition-all duration-300 whitespace-nowrap cursor-pointer group"
        aria-label="Book a Session"
      >
        <span className="w-9 h-9 flex items-center justify-center bg-white/20 rounded-full group-hover:bg-white/30 transition-colors duration-200">
          <i className="ri-calendar-check-line text-lg"></i>
        </span>
        <span className="text-base">Book a Session</span>
        <i className="ri-arrow-right-line text-base group-hover:translate-x-1 transition-transform duration-200"></i>
      </button>

      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-emerald-500/30 animate-ping pointer-events-none" style={{ animationDuration: '2.5s' }}></span>
    </div>
  );
}
